import {
    CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_REQUEST,
    CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_SUCCESS,
    CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_FAILURE,

    CORE_LOAD_MASTER_DATA_PAINT_LOCATION_REQUEST,
    CORE_LOAD_MASTER_DATA_PAINT_LOCATION_SUCCESS,
    CORE_LOAD_MASTER_DATA_PAINT_LOCATION_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterPaintLocations: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_FAILURE:
                return []
            default:
                return state
        }
    },
    masterPaintLocation: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_PAINT_LOCATION_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_PAINT_LOCATION_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_PAINT_LOCATION_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/paintLocation.js